import React from 'react';
import { UserShape, NotificationPreferencesShape } from '../../shapes';
import PropTypes from 'prop-types';
import Waiting from '../waiting';
import NotificationPreferencesForm from './form';

export default class NotificationPreferences extends React.Component {
  static propTypes = {
    user: UserShape,
    notificationPreferences: NotificationPreferencesShape,
    onLoadNotificationPreferences: PropTypes.func,
    onUpdateNotificationPreferences: PropTypes.func
  }

  componentDidMount() {
    this.props.onLoadNotificationPreferences();
  }

  render() {
    if (this.props.notificationPreferences.get('loading')) {
      return this.renderWaiting();
    } else {
      return this.renderForm();
    }
  }

  renderForm() {
    return (
      <NotificationPreferencesForm user={ this.props.user } notificationPreferences={ this.props.notificationPreferences } onUpdateNotificationPreferences={ this.props.onUpdateNotificationPreferences } />
    )
  }

  renderWaiting() {
    return(<Waiting waitingText={ 'Crunching' } />);
  }
}



// WEBPACK FOOTER //
// ./src/components/notification_preferences/index.jsx